import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { Accessory } from '../../../@types/item';
import OverflowSwipe from '../../../components/overflow-swipe';
import Content from '../../../styled-components/components/Content';
import { H3 } from '../../../styled-components/components/Heading';
import { StackMedium } from '../../../styled-components/components/Stack';
import AccessoryItem from './accessory';
import AccessoryModal from './accessory-modal';

interface AccessoriesProps {
  accessories?: Accessory[];
}

const Accessories = ({ accessories }: AccessoriesProps) => {
  const { t } = useTranslation(['item']);
  const [modal, setModal] = useState<Accessory | undefined>();
  const onOpenAccessoryModal = useCallback((accessory: Accessory) => setModal(accessory), []);
  const onCloseAccessoryModal = useCallback(() => setModal(undefined), []);

  if (!accessories?.length) return null;

  return (
    <>
      {modal && <AccessoryModal accessory={modal} onClose={onCloseAccessoryModal} />}
      <div className="item-section item-section-full-width">
        <StackMedium>
          <H3 as="h2" $margin="small">
            {t('accessories.heading', { ns: 'item' })}
          </H3>
          <Content>
            <p>{t('accessories.description', { ns: 'item' })}</p>
          </Content>
        </StackMedium>
        <StackMedium>
          <OverflowSwipe visibleItems={3} visibleItemsMobile={1}>
            {accessories.map((accessory) => (
              <AccessoryItem
                key={accessory.id}
                accessory={accessory}
                onClick={onOpenAccessoryModal}
              />
            ))}
          </OverflowSwipe>
        </StackMedium>
      </div>
    </>
  );
};

export default Accessories;
